class FBF_Newsletter{

   constructor( formId, locale ){

      this.formId = formId;

      this.locale = locale;

      this.apiBaseUrl = 'https://buskers.ferrarabuskers.com';

      this.token = 'a0fcb8e735db9abfe7e7eef16a23a556fad4c3bb'

      this.settings = null;

      this.init();

   }

   init = () => {

      const _self = this;
      
      try{

         fetch( `${this.apiBaseUrl}/api/anagrafiche/settings/`, {
            method: 'GET',
            headers: {
               'Content-Type': 'application/json',
               'Authorization': `Token ${this.token}`
            }
         })
         .then( response => response.json() )
         .then( data => {

            console.log('SETTINGS', data);
            _self.settings = data;
            _self.setListeners();

         });

      }catch(error){

         console.log('ERROR', error);

      }

   }

   checkForRequiredCitta = (nazione) => {

      const formElement = document.getElementById( this.formId );
      const fieldCitta = formElement.querySelector(`#${this.formId}-citta`);

      if( nazione !== 'IT' )
      {
         fieldCitta.removeAttribute('hidden');
         fieldCitta.name = 'citta';
         fieldCitta.required = true;
      }else{
         fieldCitta.hidden = true;
         fieldCitta.removeAttribute('name');
         fieldCitta.required = false;
      }

   }

   toJson = (formData) => {
      const object = {};
      formData.forEach( (value, key) => {
         object[key] = value;
      });
      return object;
   }

   handleFormSubmit = async () => {

      const _self = this;
      const formElement = document.getElementById( this.formId );
      const feedback = formElement.querySelector('.response');

      feedback.innerHTML = '';

      const errorLabels = formElement.querySelectorAll('.field-error');
      if( errorLabels.length > 0 )
      {
         errorLabels.forEach( label => {
            label.remove();
         });
      }

      const fields = formElement.querySelectorAll('[name]');
      const invalidFields = [...fields].filter( field => !field.validity.valid );
      

      if( invalidFields.length > 0 )
      {
         invalidFields.forEach( field => {
            let errorMessage = window.i18n['general.newsletter_form.popup.missingValue'];
            if( field.validity.patternMismatch )
            {
               errorMessage = window.i18n['general.newsletter_form.popup.patternMismatch'];
            }
            const d = document.createElement('div');
            d.classList.add('field-error');
            d.textContent = errorMessage;
            field.insertAdjacentElement('afterend', d);
         });

         return;
      }

      const formData = new FormData(formElement);
      const jsonData = this.toJson(formData);
      
      Object.keys(jsonData).forEach(key =>
      {
         if ( key === 'provincia' )
         {
            const currentValue = jsonData[key];
            jsonData[key] = { id: Number(currentValue) };
         }else if ( key === 'nazione' )
         {
            const currentValue = jsonData[key];
            jsonData[key] = { id: currentValue };
         }
      });

      try{
         formElement.classList.add('submitting');
         const subscribe = await fetch(`${this.apiBaseUrl}/api/newsletter/${this.locale}/`, {
            method: 'POST',
            headers: {
               'Content-Type': 'application/json',
               'Authorization': `Token ${this.token}`
            },
            body: JSON.stringify({
               data: jsonData
            })
         }).then( res => res.json() );

         const s = document.createElement('div');
         s.classList.add('alert','alert-success');
         s.textContent = window.i18n['general.newsletter_form.popup.success'];;
         feedback.appendChild(s);

         formElement.classList.remove('submitting');
         formElement.reset();
         
      }catch(error){
         const c = document.createElement('div');
         c.classList.add('alert','alert-danger');
         c.textContent = error.message;
         feedback.appendChild(c);
         formElement.classList.remove('submitting');
      }

   }

   setListeners = () => {

      const _self = this;
      const formElement = document.getElementById( this.formId );

      if( formElement )
      {
         const submitButton = formElement.querySelector(`#${this.formId}-submit`);
         const acceptance = formElement.querySelector(`#${this.formId}-acceptance`);
         const provinceSelector = formElement.querySelector(`#${this.formId}-provincia`);
         const nazioneSelector = formElement.querySelector(`#${this.formId}-nazione`);
         const fieldCitta = formElement.querySelector(`#${this.formId}-citta`);

         acceptance.addEventListener( 'change', () => {
            submitButton.disabled = !acceptance.checked;
         });

         if( provinceSelector && this.settings?.province.length > 0 )
         {
            this.settings.province.forEach( provincia => {
               const option = document.createElement('option');
               option.value = provincia.id;
               option.text = provincia.name;
               provinceSelector.appendChild(option);
            });
         }

         if( nazioneSelector && this.settings?.nazioni.length > 0 )
         {
            this.settings.nazioni.forEach( nazione => {
               const option = document.createElement('option');
               option.value = nazione.id;
               option.text = nazione.name;
               nazioneSelector.appendChild(option);
            });
         }

         if( fieldCitta && nazioneSelector )
         {
            _self.checkForRequiredCitta( nazioneSelector.value );

            nazioneSelector.addEventListener( 'change', (event) => {
               _self.checkForRequiredCitta( event.target.value );
            });
         }

         submitButton.addEventListener( 'click', () => {
            this.handleFormSubmit();
         });
      }

   }

}